import streamfields from '@/streamfields';
import type { Streamfield } from '@/types';

type Props = {
  fields: Streamfield[];
};

function Streamfields(props: Props) {
  const { fields } = props;
  const getProps = (field: Streamfield) => {
    if (typeof field.value === 'string') return { value: field.value };
    return field.value;
  };

  if (!fields?.length) return null;

  return (
    <>
      {fields.map(field => {
        const Component = streamfields[field.type];
        if (!Component) {
          return (
            <h2 key={field.id}>
              Component <strong>{field.type}</strong> not found
            </h2>
          );
        }

        return <Component key={field.id} {...getProps(field)} />;
      })}
    </>
  );
}

export default Streamfields;
